import { Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss'
})
export class WalletComponent {
  dataSource: any;

  constructor(private environmentService: EnvironmentService) {}
  ngOnInit() {
    this.dataSource = new DataSource({
      store: new ODataStore({
        url: this.environmentService.getConfig('BackendApi') + "odata/Cards?$expand=Wallet",
        key: "Id"
      })
    });
  }
}
